export default "__VITE_ASSET__oOdQuuJF__"